import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-[1240px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                瓜
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                爆瓜爆料社
              </span>
            </div>
            <p className="mt-4 text-sm leading-6 text-secondary-200">
              汇总全网热门爆料，把散落的信息整理成清晰的瓜田地图。每天花五分钟，看完全网最值得看的瓜。
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold text-background-50">内容分类</h2>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="cursor-pointer text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold text-background-50">关于本站</h2>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="cursor-pointer text-sm text-secondary-200 transition-colors hover:text-accent-300"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="cursor-pointer text-sm text-secondary-200 transition-colors hover:text-accent-300"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="cursor-pointer text-sm text-secondary-200 transition-colors hover:text-accent-300"
                >
                  投稿爆料
                </Link>
              </li>
              <li>
                <Link
                  to="/about#principles"
                  className="cursor-pointer text-sm text-secondary-200 transition-colors hover:text-accent-300"
                >
                  内容原则
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold text-background-50">联系我们</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-secondary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" aria-hidden="true" />
                tip@baogua-portal.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" aria-hidden="true" />
                每日 08:00 更新精选内容
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400" aria-hidden="true" />
                未经证实信息不作定论
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 爆瓜爆料社 · 内容仅供娱乐参考，不构成事实认定</p>
          <p>本站内容为编辑整理，如涉侵权请联系删除</p>
        </div>
      </div>
    </footer>
  );
}